import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { canAccessPath } from '../utils/permissions';

/**
 * Giriş yapmış kullanıcının rolüne göre sayfa erişimini kontrol eder.
 * Yetkisiz path'e redirect edilirse /dashboard'a yönlendirir.
 */
export const RoleRouteGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const path = location.pathname.replace(/\/$/, '') || '/';
  const roleCodes = user?.roleCodes ?? [];

  if (canAccessPath(path, roleCodes)) {
    return <>{children}</>;
  }

  return <Navigate to="/dashboard" replace />;
};
